<script setup>
</script>

<template>
    <div class="modal">
        <div>
            <slot></slot>
        </div>
    </div>
</template>

<style scoped>

.modal{
    height: 100vh;
}

.modal >div{
    background-color: #f0fdff;
	padding: 30px;
	border-radius: 20px;
	border-color: black;
	border-style: solid;
	line-height: 3rem;
}

</style>